import React, { useEffect, useState, useRef } from "react";
import { isMobile } from "react-device-detect";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { ICON } from "../../constants";
import clsx from "clsx";
import useStyles from "./styles";
import commonStyles from "../commonStyles";
import CustomPopup from "../Common/CustomPopup";
import SiteDrawer from "../Common/siteDrawer";
import DrawerHeader from "../Common/DrawerHeader";
import MobileFooter from "../Footer/MobileFooter";
import DeskFooter from "../Footer/DeskFooter";
import { getSvgIcon } from "../../svgUtility";

function HostGamePage() {
  const comClasses = commonStyles();
  const classes = useStyles();
  const formSectionRef = useRef(null);
  const formRef = useRef(null);
  const faqSectionRef = useRef(null);
  const hostFeatureGroupRef = useRef(null);
  const playerFeatureGroupRef = useRef(null);
  const faqDrawerAutoOpenedRef = useRef(false);
  const youtubeUrl = "https://www.youtube.com/embed/8uH_1vld7a8";

  const [isTabletOrMobile, setIsTabletOrMobile] = useState(
    window.innerWidth <= 1024,
  );

  const [registerDrawer, setRegisterDrawer] = useState(false);
  const [userName, setUserName] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [sports, setSports] = useState();
  const [venueName, setVenueName] = useState();
  const [otherInfo, setOtherInfo] = useState();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState();
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [showAllHostFeatures, setShowAllHostFeatures] = useState(false);
  const [showAllPlayerFeatures, setShowAllPlayerFeatures] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.history.scrollRestoration = "manual";

    window.scrollTo(0, 0);

    return () => {
      window.history.scrollRestoration = "auto";
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth > 767) {
      return;
    }

    const faqSection = faqSectionRef.current;

    if (!faqSection) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !faqDrawerAutoOpenedRef.current) {
          faqDrawerAutoOpenedRef.current = true;
          setRegisterDrawer(true);
        }
      },
      {
        threshold: 0.2,
      },
    );

    observer.observe(faqSection);

    return () => {
      observer.disconnect();
    };
  }, []);

  const sportsData = [
    "Cricket",
    "Football",
    "Badminton",
    "Pickleball",
    "Tennis",
    "Basketball",
    "Table Tennis",
    "Volleyball",
    "Running & Fun Runs",
    "Swimming",
    "Paddle",
  ];

  const hostFeatures = [
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/for-host-step-1.png",
      title: "Create in 3 steps",
      description:
        "Choose your sport, date and game details, then publish your game in minutes.",
    },
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/for-host-step-2.png",
      title: "Paid / Pending Tally",
      description:
        "Quickly see which players have paid and which payments are still pending.",
    },
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/for-host-step-3.png",
      title: "Let us collect for you",
      description: "Manage player payment status from one convenient place.",
    },
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/for-host-step-4.png",
      title: "Duplicate your games",
      description:
        "Hosting regularly? Duplicate an existing game instead of creating the same game from scratch.",
    },
  ];

  const playerFeatures = [
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/player-step-1-hg.png",
      title: "Discover games nearby",
      description:
        "Find sports games happening around you and discover more opportunities to play.",
    },
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/player-step-2.png",
      title: "Join instantly",
      description:
        "Found the right game? Check the details and join available slots quickly.",
    },
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/player-step-3.png",
      title: "See who's playing",
      description:
        "View participating players before the game and know who you'll be playing with.",
    },
    {
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/player-step-4.png",
      title: "Live Game Updates",
      description:
        "Stay informed with game updates so you don't miss important changes or cancellations.",
    },
  ];

  const faqData = [
    {
      question: "How do I host a game on KheloMore?",
      answer:
        "Choose your sport, date, time and location, add your game details and publish your listing. Players can then discover your game and join available slots.",
    },

    {
      question: "How do I join a game on KheloMore?",
      answer:
        "Browse available games, choose a game that matches your preferred sport, location and level, check the game details and join an available slot.",
    },

    {
      question: "How can I find sports games near me?",
      answer:
        "Use KheloMore to discover available games in your area. You can explore games based on sport and location and choose one that works for you.",
    },

    {
      question: "What sports can I host or join on KheloMore?",
      answer:
        "KheloMore supports multiple sports, including Cricket, Football, Badminton, Pickleball, Tennis, Basketball, Table Tennis, Volleyball, Running, Swimming and Padel, subject to games being available in your location.",
    },

    {
      question: "Can KheloMore help me find players for my game?",
      answer:
        "Yes. Once your game is published, it can be discovered by players looking for relevant games in their area, helping you fill available player slots.",
    },

    {
      question: "Can I choose the skill level for my game?",
      answer:
        "Yes. While setting up your game, you can specify player-related details such as skill level and participant requirements so players can understand whether the game is right for them.",
    },

    {
      question: "Can I see who has joined my game?",
      answer:
        "Yes. Hosts can see participating players and manage their game from KheloMore.",
    },

    {
      question: "Can players see who else is joining?",
      answer:
        "Yes. Players can see who has joined before they play, helping them know more about the group they are joining.",
    },

    {
      question: "Can I track player payments?",
      answer:
        "KheloMore provides hosts with payment-status information so they can see paid and pending players and manage their game more easily.",
    },

    {
      question: "Can I create the same game again?",
      answer:
        "Yes. If you regularly host similar games, KheloMore's duplicate-game option helps you reuse an existing game instead of creating it again from scratch.",
    },

    {
      question: "Can I chat with players who join my game?",
      answer:
        "Yes. Hosts can use game chat to communicate with players, coordinate plans and share important updates.",
    },

    {
      question: "What happens if there is a change to the game?",
      answer:
        "KheloMore provides game updates so participants can stay informed about important changes or cancellations.",
    },

    {
      question: "What happens after I submit the hosting enquiry form?",
      answer:
        "The KheloMore team will contact you to help you understand the hosting process and get started with your first game.",
    },

    {
      question: "What support do I get as a host?",
      answer:
        "KheloMore helps simplify game creation, player discovery, payment tracking and communication so you can spend less time coordinating and more time playing.",
    },
  ];

  const scriptURL =
    "https://script.google.com/macros/s/AKfycbyFA0iMk1yTkkcndN9qwHS1wsWV1j5N2Ea6nKCyt0pnZJwiZPTaJeHMTuw3KZB01rsM/exec";
  // const form = document.forms["google-sheet"];

  const handleHostGame = () => {
    if (isTabletOrMobile) {
      setRegisterDrawer(true);
    } else {
      scrollToForm();
    }
  };

  const scrollToForm = () => {
    formSectionRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleFaqToggle = () => {
    if (showAllFaqs) {
      setShowAllFaqs(false);

      setTimeout(() => {
        faqSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 0);
    } else {
      setShowAllFaqs(true);
    }
  };

  const handleChange = (event) => {
    let key = event.target.name;
    let value = event.target.value;
    switch (key) {
      case "name":
        setUserName(value);
        break;
      case "mobileNumber":
        setPhone(value);
        break;
      case "city":
        setAddress(value);
        break;
      case "gamesWantToHost":
        setSports(value);
        break;

      case "venueName":
        setVenueName(value);
        break;

      case "Any other information share":
        setOtherInfo(value);
        break;

      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    window.fbq("track", "Subscribe", {
      currency: "INR",
      name: userName,
      mobileNumber: phone,
    });

    if (
      userName?.length &&
      phone?.length &&
      address?.length &&
      sports?.length
    ) {
      let formData = new FormData(formRef.current);
      formData.append("dateTime", new Date()?.toLocaleString());
      fetch(scriptURL, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      })
        .then((response) => {
          setConfirmDialogOpen(true);
        })
        .catch((error) => console.error("Error!", error.message));
    }
    setRegisterDrawer(false);
    setUserName("");
    setPhone("");
    setAddress("");
    setSports("");
    setVenueName("");
    setOtherInfo("");
  };

  const clearData = () => {
    if (registerDrawer) {
      setUserName("");
      setPhone("");
      setAddress("");
      setSports("");
      setVenueName("");
      setOtherInfo("");
    }
  };

  const handleConfirmBackClose = (event, action) => {
    if (event) event.preventDefault();
    setConfirmDialogOpen(false);
  };

  const collapseAndScrollToSection = (setExpanded, sectionRef) => {
    setExpanded(false);

    requestAnimationFrame(() => {
      sectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  };

  const renderHostGameForm = () => (
    <form
      ref={formRef}
      onSubmit={handleSubmit}
      autoComplete="off"
      name="google-sheet"
    >
      <div className={classes.formGrid}>
        <input
          type="text"
          value={userName}
          name="name"
          onChange={handleChange}
          placeholder="Full Name *"
          className={classes.participantInput}
        />

        <input
          type="number"
          value={phone}
          name="mobileNumber"
          onChange={handleChange}
          placeholder="Mobile Number *"
          className={classes.participantInput}
        />

        <input
          type="text"
          value={address}
          name="city"
          onChange={handleChange}
          placeholder="City *"
          className={classes.participantInput}
        />

        <input
          type="text"
          value={sports}
          name="gamesWantToHost"
          onChange={handleChange}
          placeholder="Games you want to host *"
          className={classes.participantInput}
        />
      </div>

      <div className={clsx(classes.finalBox2, comClasses.mT32)}>
        <div className={classes.finalBtn2}>
          {userName && phone && address && sports ? (
            <button
              type="submit"
              className={clsx(classes.finalButton2, classes.orangeBg)}
            >
              HELP ME HOST MY GAME
            </button>
          ) : (
            <button
              type="button"
              disabled
              className={clsx(classes.finalButton2, classes.disabled)}
            >
              HELP ME HOST MY GAME
            </button>
          )}
        </div>
      </div>
    </form>
  );

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Host or Join Sports Games Near You | KheloMore</title>
        <meta
          name="description"
          content="Host your own cricket, football, badminton, pickleball or tennis game, find players near you, or discover and join sports games with KheloMore."
        />
        <meta
          name="keywords"
          content="host a game, host cricket game, host football game, host badminton game, host pickleball game, host padel game, host running game, host swimming game, host tennis game, find player near you, sports game hosting, KheloMore"
        />
        <link rel="canonical" href={window.location.href} />
        <meta
          property="og:title"
          content="Host or Join Sports Games Near You | KheloMore"
        />
        <meta
          property="og:description"
          content="Host your own cricket, football, badminton, pickleball or tennis game, find players near you, or discover and join sports games with KheloMore."
        />
        <meta property="og:url" content={window.location.href} />
        ----------------OGCard Section -------------------------
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="En" />
      </Helmet>

      <header
        className={clsx(
          classes.flex,
          classes.spaceBw,
          classes.alignCenter,
          classes.downShadow,
        )}
      >
        <div>
          <Link to="/">
            <img
              className={classes.kmImage}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/emailers/km-com-new-logo.png"
              alt="khelomore"
            />
          </Link>
        </div>
        <div
          className={clsx(
            classes.flex,
            classes.justifyCenter,
            classes.alignCenter,
          )}
        >
          <button
            onClick={handleHostGame}
            className={clsx(
              classes.ctaTwo,
              classes.flex,
              classes.justifyCenter,
              classes.alignCenter,
            )}
          >
            Host Your Game
          </button>
        </div>
      </header>

      <main className={classes.hostGamePage}>
        {/* SLOTS BANNER */}
        <div className={classes.slotsBanner}>Your slots, filled faster</div>
        {/* =========================================
            HERO SECTION
        ========================================== */}

        <section
          className={classes.heroSection}
          aria-labelledby="host-game-title"
        >
          <div className={classes.heroContainer}>
            {/* LEFT CONTENT */}

            <div className={classes.heroContent}>
              <div className={classes.heroEyebrow}>
                FOR PLAYERS, HOSTS & ORGANISERS
              </div>

              <h1 id="host-game-title" className={classes.heroTitle}>
                Your Game.
                <span className={classes.heroTitleAccent}>Your Rules.</span>
              </h1>
              <h2
                style={{ textTransform: "none" }}
                className={classes.heroEyebrow}
              >
                Host a game or join one near you with KheloMore.
              </h2>
              <p className={classes.heroDescription}>
                Create your own Cricket, Football, Badminton, Pickleball, Tennis
                or other sports game in minutes. Set the location, time, player
                level and price or discover nearby games, join players in your
                area and get playing.
              </p>

              <button
                type="button"
                className={clsx(
                  classes.hostGameButton,
                  classes.hostGameButtonLarge,
                )}
                onClick={handleHostGame}
              >
                Host Your Game
                <span aria-hidden="true">»</span>
              </button>
            </div>

            {/* RIGHT GAME PREVIEW */}

            <article className={classes.heroGameCard}>
              <div className={classes.gameCardHeader}>
                <div className={classes.gameCardIcon} aria-hidden="true">
                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/tape-ball-hg.png"
                    alt=""
                  />
                </div>

                <div className={classes.gameCardHeading}>
                  <h2 className={classes.gameCardTitle}>
                    Rahul M&apos;s Cricket Tape Ball Match
                  </h2>

                  <p className={classes.gameCardLocation}>
                    Arena X, Koramangala • 2.1 Km
                  </p>
                </div>
              </div>

              <div className={classes.gameCardTime}>
                <span aria-hidden="true">☀️</span>

                <span>
                  07:00 AM - 08:30 AM&nbsp; | &nbsp;Saturday, 12th April
                </span>
              </div>

              <div className={classes.gameCardSkillRow}>
                <div className={classes.gameCardSkill}>
                  Intermediate - Advanced
                </div>

                <div className={classes.gameCardInstantJoin}>
                  <span aria-hidden="true">⚡</span>
                  <span>Instant Join</span>
                </div>
              </div>

              <div className={classes.gameCardDivider} />

              <div className={classes.gameCardHostRow}>
                <div className={classes.gameCardAvatar} aria-hidden="true">
                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/user-icon-hg-card.png"
                    alt=""
                  />
                </div>

                <div className={classes.gameCardHostName}>
                  Rahul M
                  <span
                    className={classes.gameCardVerified}
                    aria-label="Verified host"
                  >
                    ✔
                  </span>
                </div>

                <div className={classes.gameCardTopHost}>🏆 Top Host</div>

                <div className={classes.gameCardCapacity}>6/10</div>

                <div className={classes.gameCardSlots}>🔥 Only 4 Left!</div>
              </div>

              <div className={classes.gameCardPrice}>₹435 / Person</div>

              <p className={classes.gameCardJoining}>
                • Arjun and 2 others from your network are joining
              </p>
            </article>
          </div>
        </section>

        {/* =========================================
            POPULAR SPORTS
        ========================================== */}

        <section
          className={classes.sportsSection}
          aria-labelledby="popular-sports-title"
        >
          <div className={classes.sportsContainer}>
            <h2
              id="popular-sports-title"
              className={classes.sportsSectionTitle}
            >
              Popular Sports to Host
            </h2>

            <ul className={classes.sportsList}>
              {sportsData.map((sport) => (
                <li key={sport} className={classes.sportsChip}>
                  {sport}
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* =========================================
    HOW IT WORKS
========================================== */}

        <section>
          <div className={classes.howItWorksContainer}>
            <h2 id="how-it-works-title" className={classes.howItWorksTitle}>
              How It <span>Works?</span>
            </h2>
            <p className={classes.howItWorksPara}>
              Whether you want to host a sports game or join a game near you,
              KheloMore makes it simple to get started.
            </p>

            <div className={classes.howItWorksSteps}>
              {/* =========================================
          STEP 1
      ========================================== */}

              {/* =========================================
    STEP 1
========================================== */}

              <div className={classes.howItWorksStep}>
                {/* STEP 1 IMAGE */}
                <div className={classes.stepVisual}>
                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/step-1-mobile.png"
                    alt="Create a sports game on KheloMore"
                    className={classes.stepImage}
                  />
                </div>

                {/* STEP 1 TEXT + ARROW */}
                <div className={classes.stepContentWithArrow}>
                  <p className={classes.stepLabel}>Step 1 - Create</p>

                  <h3 className={classes.stepTitle}>SET UP YOUR GAME</h3>

                  <p className={classes.stepDescription}>
                    Sport, Date, Time &amp; Location
                  </p>

                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/arrow-step-1.png"
                    alt=""
                    aria-hidden="true"
                    className={classes.stepOneArrow}
                  />
                </div>
              </div>

              {/* =========================================
          STEP 2
      ========================================== */}

              <div
                className={`${classes.howItWorksStep} ${classes.stepReverse}`}
              >
                <div className={classes.stepVisual}>
                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/step-2-mobile-hg.png"
                    alt="Customize skill level, gender and participant count"
                    className={classes.stepImage}
                  />
                </div>

                <div className={classes.stepContent}>
                  <p className={classes.stepLabel}>Step 2 - Customize</p>

                  <h3 className={classes.stepTitle}>MAKE IT YOURS</h3>

                  <p className={classes.stepDescription}>
                    Skill level, player preferences, participant count &amp;
                    other game details
                  </p>
                </div>
              </div>

              {/* STEP 2 → STEP 3 ARROW */}

              <div className={classes.stepArrow}>
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/arrow-step-2.png"
                  alt=""
                  aria-hidden="true"
                />
              </div>

              {/* =========================================
          STEP 3
      ========================================== */}

              <div className={classes.howItWorksStep}>
                <div className={classes.stepVisual}>
                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/step-3-mobile-hg.png"
                    alt="Preview and publish your sports game"
                    className={classes.stepImage}
                  />
                </div>

                <div className={classes.stepContent}>
                  <p className={classes.stepLabel}>Step 3 - Publish</p>

                  <h3 className={classes.stepTitle}>GO LIVE INSTANTLY</h3>

                  <p className={classes.stepDescription}>
                    Preview &amp; Publish in one tap so players looking for
                    games nearby can discover and join
                  </p>
                </div>
              </div>

              {/* STEP 3 → STEP 4 ARROW */}

              <div className={classes.stepArrow}>
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/arrow-step-3.png"
                  alt=""
                  aria-hidden="true"
                />
              </div>

              {/* =========================================
          STEP 4
      ========================================== */}

              <div
                className={`${classes.howItWorksStep} ${classes.stepReverse}`}
              >
                <div className={classes.stepVisual}>
                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/step-4-mobile-hg.png"
                    alt="Manage players and payments for your game"
                    className={classes.stepImage}
                  />
                </div>

                <div className={classes.stepContent}>
                  <p className={classes.stepLabel}>Step 4 - Manage</p>

                  <h3 className={classes.stepTitle}>STAY IN CONTROL</h3>

                  <p className={classes.stepDescription}>
                    See who's joining, manage available slots and keep track of
                    player payments all in one place.
                  </p>
                </div>
              </div>

              {/* STEP 4 → STEP 5 ARROW */}

              <div className={classes.stepArrow}>
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/arrow-step-4.png"
                  alt=""
                  aria-hidden="true"
                />
              </div>

              {/* =========================================
          STEP 5
      ========================================== */}

              <div className={classes.howItWorksStep}>
                <div className={classes.stepVisual}>
                  <img
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/step-5-mobile.png"
                    alt="Chat and coordinate with players for your game"
                    className={classes.stepImage}
                  />
                </div>

                <div className={classes.stepContent}>
                  <p className={classes.stepLabel}>Step 5 - Ready to Play</p>

                  <h3 className={classes.stepTitle}>CHAT &amp; COORDINATE</h3>

                  <p className={classes.stepDescription}>
                    Connect with your players, share updates and coordinate game
                    details before you play.
                  </p>
                </div>
              </div>
            </div>

            {/* =========================================
        SECTION CTA
    ========================================== */}

            <div className={classes.howItWorksCta}>
              <button
                type="button"
                className={classes.hostGameButton}
                onClick={handleHostGame}
              >
                Host Your Game
              </button>
            </div>
          </div>
        </section>

        {/* =========================================
    DOWNLOAD APP BANNER
========================================== */}

        <section className={classes.downloadAppSection}>
          <a
            href="https://linktr.ee/khelo_more"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download the KheloMore app"
            className={classes.downloadAppLink}
          >
            <picture>
              {/* Mobile */}
              <source
                media="(max-width: 767px)"
                srcSet="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/newMobAppBanner.png"
              />

              {/* Desktop + Tablet */}
              <img
                src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/dwnld-app.png"
                alt="Download the KheloMore app"
                className={classes.downloadAppImage}
              />
            </picture>
          </a>
        </section>

        {/* =========================================
    HOW HOSTING ON KHELOMORE WORKS
========================================== */}

        <section
          className={classes.hostingGuideSection}
          aria-labelledby="hosting-guide-title"
        >
          <div className={classes.hostingGuideContainer}>
            <div className={classes.hostingGuideHeader}>
              <h2
                id="hosting-guide-title"
                className={classes.hostingGuideTitle}
              >
                How Hosting on KheloMore works?
              </h2>
            </div>

            <div className={classes.hostingGuideList}>
              {/* =========================================
          CARD 1
      ========================================== */}

              <article className={classes.hostingGuideCard}>
                <div className={classes.hostingGuideVideo}>
                  <iframe
                    src={youtubeUrl}
                    title="How to Host a Game on KheloMore"
                    className={classes.hostingGuideIframe}
                    allowFullScreen
                  />
                  {/* <div className={classes.videoPlaceholder}>
                    <span className={classes.videoPlaceholderIcon}>▶</span>

                    <span className={classes.videoPlaceholderText}>
                      Hosting Guide
                    </span>
                  </div> */}
                </div>

                <div className={classes.hostingGuideCardContent}>
                  <h3 className={classes.hostingGuideCardTitle}>
                    How to host your first game?
                  </h3>

                  {/* <p className={classes.hostingGuideCardDescription}>
                    Watch a quick walkthrough of hosting a match
                  </p> */}

                  <p className={classes.hostingGuideCardDescription}>
                    Create your first sports game on KheloMore from choosing
                    your sport and location to publishing your game and finding
                    players
                  </p>
                </div>
              </article>

              {/* =========================================
          CARD 2
      ========================================== */}

              {/* <article className={classes.hostingGuideCard}>
                <div className={classes.hostingGuideVideo}>
                  <div className={classes.videoPlaceholder}>
                    <span className={classes.videoPlaceholderIcon}>▶</span>

                    <span className={classes.videoPlaceholderText}>
                      Hosting Guide
                    </span>
                  </div>
                </div>

                <div className={classes.hostingGuideCardContent}>
                  <h3 className={classes.hostingGuideCardTitle}>
                    How players find & join your game?
                  </h3>

                  <p className={classes.hostingGuideCardDescription}>
                    See what your listing looks like to players nearby
                  </p>
                </div>
              </article> */}
            </div>
          </div>
        </section>
        {/* =========================================
    BENEFITS FOR HOSTS
========================================== */}

        <section
          className={classes.hostBenefitsSection}
          aria-labelledby="host-benefits-title"
        >
          <div className={classes.hostBenefitsContainer}>
            <h2 id="host-benefits-title" className={classes.hostBenefitsTitle}>
              Benefits for Hosts
            </h2>

            <div className={classes.hostBenefitsGrid}>
              <div className={classes.hostBenefitItem}>
                <div className={classes.hostBenefitCheck}>✓</div>

                <p>
                  <strong>Find players in your area - </strong>
                  Get discovered by players looking for sports games near them,
                  matched by sport, skill level and location.
                </p>
              </div>

              <div className={classes.hostBenefitItem}>
                <div className={classes.hostBenefitCheck}>✓</div>

                <p>
                  <strong>Create Games in Minutes -</strong> Our simple, guided
                  process helps you create and publish your game quickly.
                </p>
              </div>

              <div className={classes.hostBenefitItem}>
                <div className={classes.hostBenefitCheck}>✓</div>

                <p>
                  <strong>Stay Connected -</strong> Chat with players who join
                  your game and keep everyone updated in one place.
                </p>
              </div>

              <div className={classes.hostBenefitItem}>
                <div className={classes.hostBenefitCheck}>✓</div>

                <p>
                  <strong>Fill Your Available Slots -</strong> Make your game
                  discoverable and help interested players find and join your
                  available slots.
                </p>
              </div>

              <div className={classes.hostBenefitItem}>
                <div className={classes.hostBenefitCheck}>✓</div>

                <p>
                  <strong>Track Player Payments -</strong> See who has paid and
                  who hasn't, helping you manage game payments more easily.
                </p>
              </div>

              <div className={classes.hostBenefitItem}>
                <div className={classes.hostBenefitCheck}>✓</div>

                <p>
                  <strong>Focus on Playing -</strong> Spend less time
                  coordinating players and more time enjoying the game.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* =========================================
    EVERYTHING YOU GET
========================================== */}

        <section
          className={classes.featureHighlightsSection}
          aria-labelledby="feature-highlights-title"
        >
          <div className={classes.featureHighlightsContainer}>
            {/* SECTION HEADER */}

            <div className={classes.featureHighlightsHeader}>
              <h2
                id="feature-highlights-title"
                className={classes.featureHighlightsTitle}
              >
                Everything You Get, In One Place
              </h2>

              <p className={classes.featureHighlightsSubtitle}>
                Everything you need to host games, find players and join sports
                games near you.
              </p>
            </div>

            {/* =========================================
    FOR HOSTS
========================================== */}

            <div
              ref={hostFeatureGroupRef}
              className={`${classes.featureGroup} ${classes.hostFeatureGroup}`}
            >
              {/* =========================================
      HOST SECTION HEADER
  ========================================== */}

              <div className={classes.featureGroupHeader}>
                <h3 className={classes.featureGroupTitle}>
                  For <span>Hosts</span>
                </h3>

                <button
                  type="button"
                  className={classes.featureAccordionToggle}
                  onClick={() => setShowAllHostFeatures((prev) => !prev)}
                  aria-expanded={showAllHostFeatures}
                  aria-controls="host-features-list"
                >
                  {/* {showAllHostFeatures ? "SEE LESS ↑" : "SEE ALL ↓"} */}
                  {"SEE ALL ↓"}
                </button>
              </div>

              {/* =========================================
      HOST FEATURES
  ========================================== */}

              <div
                id="host-features-list"
                className={clsx(
                  classes.featureAccordion,
                  showAllHostFeatures
                    ? classes.featureAccordionExpanded
                    : classes.featureAccordionCollapsed,
                )}
              >
                <div className={classes.featureAccordionContent}>
                  {hostFeatures.map((feature, index) => (
                    <React.Fragment key={feature.title}>
                      <article
                        className={clsx(
                          classes.featureCard,
                          index % 2 === 1 && classes.featureCardReverse,
                        )}
                      >
                        <div className={classes.featureImageWrapper}>
                          <img
                            src={feature.image}
                            alt={feature.title}
                            className={classes.featureImage}
                          />
                        </div>

                        <div className={classes.featureContent}>
                          <h4 className={classes.featureCardTitle}>
                            {feature.title}
                          </h4>

                          <p className={classes.featureCardDescription}>
                            {feature.description}
                          </p>
                        </div>
                      </article>

                      {index < hostFeatures.length - 1 && (
                        <div
                          className={classes.mobileFeatureArrow}
                          aria-hidden="true"
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
                {showAllHostFeatures && (
                  <div className={classes.featureAccordionBottom}>
                    <button
                      type="button"
                      className={classes.featureAccordionToggle}
                      onClick={() =>
                        collapseAndScrollToSection(
                          setShowAllHostFeatures,
                          hostFeatureGroupRef,
                        )
                      }
                      aria-expanded={true}
                      aria-controls="host-features-list"
                    >
                      SEE LESS ↑
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* =========================================
    FOR PLAYERS
========================================== */}

            <div
              ref={playerFeatureGroupRef}
              className={`${classes.featureGroup} ${classes.playerFeatureGroup}`}
            >
              {/* =========================================
      PLAYER SECTION HEADER
  ========================================== */}

              <div className={classes.featureGroupHeader}>
                <h3 className={classes.featureGroupTitle}>
                  For <span>Players Joining Your Game</span>
                </h3>

                <button
                  type="button"
                  className={classes.featureAccordionToggle}
                  onClick={() => setShowAllPlayerFeatures((prev) => !prev)}
                  aria-expanded={showAllPlayerFeatures}
                  aria-controls="player-features-list"
                >
                  {/* {showAllPlayerFeatures ? "SEE LESS ↑" : "SEE ALL ↓"} */}
                  {"SEE ALL ↓"}
                </button>
              </div>

              {/* =========================================
      PLAYER FEATURES
  ========================================== */}

              <div
                id="player-features-list"
                className={clsx(
                  classes.featureAccordion,
                  showAllPlayerFeatures
                    ? classes.featureAccordionExpanded
                    : classes.featureAccordionCollapsed,
                )}
              >
                <div className={classes.featureAccordionContent}>
                  {playerFeatures.map((feature, index) => (
                    <React.Fragment key={feature.title}>
                      <article
                        className={clsx(
                          classes.featureCard,
                          index % 2 === 1 && classes.featureCardReverse,
                        )}
                      >
                        <div className={classes.featureImageWrapper}>
                          <img
                            src={feature.image}
                            alt={feature.title}
                            className={classes.featureImage}
                          />
                        </div>

                        <div className={classes.featureContent}>
                          <h4 className={classes.featureCardTitle}>
                            {feature.title}
                          </h4>

                          <p className={classes.featureCardDescription}>
                            {feature.description}
                          </p>
                        </div>
                      </article>

                      {index < playerFeatures.length - 1 && (
                        <div
                          className={classes.mobileFeatureArrow}
                          aria-hidden="true"
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
                {showAllPlayerFeatures && (
                  <div className={classes.featureAccordionBottom}>
                    <button
                      type="button"
                      className={classes.featureAccordionToggle}
                      onClick={() =>
                        collapseAndScrollToSection(
                          setShowAllPlayerFeatures,
                          playerFeatureGroupRef,
                        )
                      }
                      aria-expanded={true}
                      aria-controls="player-features-list"
                    >
                      SEE LESS ↑
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* =========================================
    HOST YOUR GAME CTA
========================================== */}

        <section className={classes.hostGameCtaSection}>
          <h2 className={classes.hostGameNewTitle}>
            Ready to <span>Play Your Way?</span>
          </h2>
          <p className={classes.hostGameNewPara}>
            Whether you're bringing players together or looking for your next
            game, KheloMore helps you get on the field faster.
          </p>
          <a
            href={
              isTabletOrMobile
                ? "https://tna61.app.link/NvRnKF0De6b"
                : "https://linktr.ee/khelo_more"
            }
            target="_blank"
            rel="noopener noreferrer"
            className={classes.hostGameCtaButton}
          >
            HOST YOUR GAME NOW »
          </a>
        </section>

        {/* =========================================
    OR DIVIDER
========================================== */}
        {!isTabletOrMobile && (
          <>
            <div className={classes.formOrDivider}>
              <span className={classes.formOrLine} />
              <span className={classes.formOrText}>OR</span>
              <span className={classes.formOrLine} />
            </div>

            <div
              ref={formSectionRef}
              className={clsx(comClasses.mT64, classes.formContainer)}
            >
              <div className={comClasses.mB32}>
                <h2 className={clsx(classes.topHeading, classes.mB10)}>
                  Still Have Doubts?
                </h2>
                <p className={clsx(classes.talkText, classes.cardPara)}>
                  Want to host a game but need some help getting started?
                </p>
                <p className={clsx(classes.talkText, classes.cardPara)}>
                  Share your details and the KheloMore team will get in touch to
                  help you set up your first game.
                </p>
              </div>
              <div>{renderHostGameForm()}</div>
            </div>
          </>
        )}

        {/* =========================================
    LOGIN + APP DOWNLOAD
========================================= */}

        <section
          className={classes.appLinksSection}
          aria-label="KheloMore app links"
        >
          <div className={classes.appLinksContainer}>
            {/* LOGIN */}
            <p className={classes.loginText}>
              Login to{" "}
              <a
                href="https://linktr.ee/khelo_more"
                target="_blank"
                rel="noopener noreferrer"
              >
                khelomore.com
              </a>
            </p>

            {/* APP STORE / GOOGLE PLAY */}
            <div className={classes.storeLinks}>
              <a
                href="https://linktr.ee/khelo_more"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.storeLink}
                aria-label="Download KheloMore on Google Play"
              >
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/emailer-images/split-payment/Google.png"
                  alt="Get it on Google Play"
                  className={classes.storeBadge}
                />
              </a>

              <a
                href="https://linktr.ee/khelo_more"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.storeLink}
                aria-label="Download KheloMore on the App Store"
              >
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/emailer-images/split-payment/Apple.png"
                  alt="Download on the App Store"
                  className={classes.storeBadge}
                />
              </a>
            </div>

            {/* SOCIAL LINKS */}
            <div className={classes.socialLinks}>
              <a
                href="https://www.facebook.com/KheloMore/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialIcon}
                aria-label="KheloMore on Facebook"
              >
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/emailers/fb-b.png"
                  alt=""
                  aria-hidden="true"
                />
              </a>

              <a
                href="https://www.instagram.com/khelomoreindia/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialIcon}
                aria-label="KheloMore on Instagram"
              >
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/emailers/insta-b.png"
                  alt=""
                  aria-hidden="true"
                />
              </a>

              <a
                href="https://www.youtube.com/channel/UC9SRqiqrQ1v9RoNX-Lnmqbg"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialIcon}
                aria-label="KheloMore on YouTube"
              >
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/emailers/youtube-b.png"
                  alt=""
                  aria-hidden="true"
                />
              </a>

              {/* X - custom icon */}
              <a
                href="https://x.com/KheloMore"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialIcon}
                aria-label="KheloMore on X"
              >
                <span className={classes.xIcon}>𝕏</span>
              </a>

              <a
                href="https://www.linkedin.com/company/khelomore/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialIcon}
                aria-label="KheloMore on LinkedIn"
              >
                <img
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/emailers/lnkdn-b.png"
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </div>

            {/* DIVIDER */}
            <div className={classes.contactDivider} />

            {/* CONTACT */}
            <p className={classes.contactText}>
              For further assistance contact us at{" "}
              <a href="mailto:info@khelomore.com">info@khelomore.com</a>
            </p>
          </div>
        </section>

        {/* =========================================
    FAQ SECTION
========================================= */}

        <section
          ref={faqSectionRef}
          className={classes.faqSection}
          aria-labelledby="faq-title"
        >
          <div className={classes.faqContainer}>
            {/* FAQ HEADER */}

            <div className={classes.faqHeader}>
              <h2 id="faq-title" className={classes.faqTitle}>
                FAQs
              </h2>

              <button
                type="button"
                className={classes.faqToggleTop}
                onClick={handleFaqToggle}
                aria-expanded={showAllFaqs}
                aria-controls="faq-list"
              >
                {showAllFaqs ? "SEE LESS" : "SEE ALL"}
              </button>
            </div>

            {/* FAQ LIST */}

            <div id="faq-list" className={classes.faqList}>
              {faqData.map((faq, index) => (
                <article
                  key={faq.question}
                  className={clsx(
                    classes.faqItem,
                    index >= 3 && !showAllFaqs && classes.faqItemHidden,
                  )}
                >
                  <h3 className={classes.faqQuestion}>{faq.question}</h3>

                  <p className={classes.faqAnswer}>{faq.answer}</p>
                </article>
              ))}
            </div>

            {/* BOTTOM SEE LESS */}

            {showAllFaqs && (
              <div className={classes.faqBottomAction}>
                <button
                  type="button"
                  className={classes.faqToggleBottom}
                  onClick={handleFaqToggle}
                  aria-label="Show fewer frequently asked questions"
                >
                  SEE LESS
                </button>
              </div>
            )}
          </div>
        </section>

        {/* =========================================
    FINAL HOST CTA
========================================= */}

        <section className={classes.finalHostCta}>
          <div className={classes.finalHostCtaInner}>
            <div className={classes.finalHostCtaContent}>
              <p className={classes.finalHostCtaTagline}>All in one place.</p>

              <p className={classes.finalHostCtaText}>
                Ready to <span>run your game?</span>
              </p>
            </div>

            <button
              type="button"
              className={classes.finalHostCtaButton}
              onClick={handleHostGame}
            >
              HOST YOUR GAME
            </button>
          </div>
        </section>

        {isMobile ? (
          <div>
            <MobileFooter />
          </div>
        ) : (
          <div>
            <DeskFooter />
          </div>
        )}

        {isTabletOrMobile && registerDrawer ? (
          <SiteDrawer
            className={classes.customDrawerContent}
            drawerType="bottom"
            isDrawerOpen={registerDrawer}
            drawerCloseHandler={setRegisterDrawer}
            isBottomDrawer={true}
            isCustomDrawer={true}
            drawerWrapperClass={classes.drawerAutoHeight2}
            drawerBodyClass={classes.drawerBodyHeight2}
          >
            <DrawerHeader
              heading="Host Your Game"
              drawerOpen={registerDrawer}
              setDrawerOpen={setRegisterDrawer}
              clearData={clearData}
            />

            {renderHostGameForm()}
          </SiteDrawer>
        ) : (
          ""
        )}

        <CustomPopup
          // doneIcon={classes.doneIcon}
          topText={classes.topTextTwo}
          open={confirmDialogOpen}
          action1={handleConfirmBackClose}
          action2={() => setConfirmDialogOpen(false)}
          heading="Thank you, record received"
          btnText2="Close"
          icon={getSvgIcon(ICON.DONE_ICON)}
        />
      </main>
    </>
  );
}

export default HostGamePage;
